import LoginOptions from './LoginOptions.jsx';
import UserTab from '../UserTab.jsx';
import { useUIStore } from '#store';
import { shallow } from 'zustand/shallow';

export default function EntryButton() {
  const { putEvent, user } = useUIStore(
      (state) => ({
        putEvent: state.putEvent,
        user: state.user,
      }),
      shallow
    );
  return user ? <UserTab /> : <LoginOptions />;
}
